import { render, staticRenderFns } from "./staffroyalty.vue?vue&type=template&id=b4a2c822&scoped=true&"
import script from "./staffroyalty.vue?vue&type=script&lang=js&"
export * from "./staffroyalty.vue?vue&type=script&lang=js&"
import style0 from "./staffroyalty.vue?vue&type=style&index=0&id=b4a2c822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a2c822",
  null
  
)

export default component.exports